import { useEffect, useState } from "react";
import ModePaiementTable from "../../components/Paiement/modePaiement/ModePaiementTable";
import ModePaiementForm from "../../components/Paiement/modePaiement/ModePaiementForm";
import {
    getModes,
    createMode,
    deleteMode,
    updateMode,
    getModeById
  
} from "../../api/modePaiement.api";

export default function ModePaiementPage() {
  const [modes, setModes] = useState([]);
  const [modeEdit, setModeEdit] = useState(null);
  const [formOpen, setFormOpen] = useState(false);

  // 🔄 Charger les types d'entretiens
  useEffect(() => {
    loadModes();
  }, []);

  const loadModes = async () => {
    try {
      const res = await getModes();
      setModes(res.data);
    } catch (error) {
      console.error("Erreur chargement des modes", error);
    }
  };

  // ➕ Ouvrir formulaire en mode ajout
  const handleOpenAdd = () => {
    setModeEdit(null);
    setFormOpen(true);
  };

  // ✏️ Ouvrir formulaire en mode édition
  const onEdit = (mode) => {
    setModeEdit(mode);
    setFormOpen(true);
  };

  // 🗑 Supprimer
  const onDelete = async (id) => {
    if (window.confirm("Supprimer ce mode Piement ?")) {
      await deleteMode(id);
      loadModes();
    }
  };

  // 💾 Create / Update
  const onSubmit = async (data) => {
    try {
      if (modeEdit) {
        await updateMode(modeEdit.id, data);
      } else {
        await createMode(data);
      }

      setModeEdit(null);
      setFormOpen(false);
      loadModes();
    } catch (error) {
      console.error("Erreur sauvegarde le mode de paiement", error);
    }
  };

  // ❌ Fermer formulaire
  const onCancel = () => {
    setModeEdit(null);
    setFormOpen(false);
  };

  return (
    <div className="page-container">
      <h1>Listes de modes du Paiement</h1>

      <button onClick={handleOpenAdd} className="btn-add">
        Ajouter un Mode du Paiement
      </button>

      {formOpen && (
        <ModePaiementForm
          onSubmit={onSubmit}
          mode={modeEdit}
          onCancel={onCancel}
        />
      )}
     {formOpen && (
          <button onClick={() => setFormOpen(false)} className="btn-close">
            Fermer
          </button>
        )}
      <ModePaiementTable
        modes={modes}
        onEdit={onEdit}
        onDelete={onDelete}
      />
    </div>
  );
}
